<template>
    <div>
      <div class="survey-module-right-action">
          <div class="table-controls justify-between">
              <div class="table-controls-btn align-center">
              </div>
              <div class="table-controls-btn align-center">
                <input type="text" v-model="queryParams.certificateNumber" placeholder="请输入证书编号" autocomplete="off">
                <div class="table-controls-btn-item btn-color3" @click="handleQuery()">搜索</div>
                <div class="table-controls-btn-item btn-color4" @click="resetQuery()">重置</div>
              </div>
            </div>
            <div class="table-body">
              <el-table
                v-loading="loading"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                :header-cell-style="{background:'#72b701',color:'#fff'}"
              >
                <el-table-column
                  label="姓名"
                  prop="name"
                   :show-overflow-tooltip="true"
                  align="center"
                />
                <!-- <el-table-column
                  label="身份证号"
                  prop="identityCard"
                   :show-overflow-tooltip="true"
                  align="center"
                /> -->
                <el-table-column
                  label="准考证号"
                  prop="admissionTicket"
                   :show-overflow-tooltip="true"
                  align="center"
                />
                <el-table-column
                  label="证书编号"
                  prop="certificateNumber"
                  :show-overflow-tooltip="true"
                  align="center"
                />

                <el-table-column
                  label="发行时间"
                  prop="issuanceTime"
                   :show-overflow-tooltip="true"
                  align="center"
                />

              </el-table>
            </div>
            <div class="pagination-content justify-end">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.pageNum"
                  :page-size="queryParams.pageSize"
                  background
                  layout="total,prev, pager, next, jumper"
                  prev-text="上一页"
                  next-text="下一页"
                  :total="total">
                </el-pagination>
            </div>
        </div>
        
    </div>
  </template>
  
  <script>
  import { getList } from "@/api/zsgl";
  export default {
    data(){
      return{
        loading:false,
        // 列表1-start
        queryParams:{
          pageNum: 1,
          pageSize: 10,
          certificateNumber: "",
        },
        total:0,
        tableData: [],
        // 列表1-end
        identity:localStorage.getItem("identity")
      }
    },
    created(){
      if(this.identity=='admin'){
        this.handleQuery()
      }
    },
    methods:{
      handleCurrentChange(val) {
        this.queryParams.pageNum = val
        this.handleQuery()
      },
      /** 查询 */
      handleQuery() {
        this.loading = true;
        getList(this.queryParams)
          .then(({ data }) => {
            this.tableData = data.list;
            this.total = data.total;
          })
          .finally(() => {
            this.loading = false;
          });
      },
     
      /** 重置查询 */
      resetQuery() {
        this.queryParams.pageNum = 1;
        this.queryParams.certificateNumber = ''
        this.handleQuery();
      },
    }
  }
  </script>
<style scoped lang="css" src="../../views/member-page/assets/css/rem.css" />